import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api'
import { useAuthStore } from '@/stores/authStore'

/**
 * Resolves the authenticated user's org_id from the backend.
 * Replaces all inline stubs that tried to read settings.org_id
 * (which doesn't exist in the user_settings table).
 *
 * Gated on auth: the endpoint requires a JWT, so firing it for anonymous
 * BuildPage / Templates visitors just spams the console with 401s.
 */
export function useOrgId(): string | null {
  const user = useAuthStore((s) => s.user)
  const { data } = useQuery({
    queryKey: ['userOrgId'],
    enabled: !!user,
    queryFn: async () => {
      const res = await apiFetch<{ org_id: string | null }>('/api/onboarding/org-id')
      return res.org_id
    },
    staleTime: 5 * 60 * 1000,
  })
  return data ?? null
}
